import { FormlyFieldConfig } from "@ngx-formly/core";

/**
 * Function to prevent entering non valid chars.
 * @param event Keypress event
 */
export function enforceAlphabeticValidator(field: FormlyFieldConfig, event: any, useEvent?: any) {
  //    Ignore input if not valid for integers:            
  //    0 for null values
  //    8 for backspace 
  //    48-57 for 0-9 numbers
  //    45 is minus '-'
  if (event.which >= 48 &&  event.which <=57) {
    event.preventDefault();
  }
  return true;
}
